import React, { useState, useEffect, useRef, useContext, useMemo } from "react";

// Hook
export function useWindowSize() {
  const isClient = typeof window === "object";

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}

export const cumulativeOffset = function (element) {
  var top = 0,
    left = 0;
  do {
    top += element.offsetTop || 0;
    left += element.offsetLeft || 0;
    element = element.offsetParent;
  } while (element);

  return {
    top: top,
    left: left,
  };
};

// Hook
export function useHeightAvailable(container) {
  const refContent = useRef(null);
  const [currState, setCurrState] = useState({ height: 0, width: 0, top: 0 });
  const { height: winHeight } = useWindowSize();

  useEffect(() => {
    if (refContent.current) {
      const { top } = cumulativeOffset(refContent.current);

      //container && console.log(container.top);

      const currHeight =
        (container ? container.height : winHeight) -
        (top - (container ? container.top : 0));

      /*(container ? container.height : winHeight) -
        (top - (container ? container.top : 0));*/
      const currWidth = refContent.current.offsetWidth;

      if (currHeight !== currState.height || currWidth !== currState.width) {
        setCurrState({
          width: currWidth,
          height: currHeight,
          top,
        });
      }
    }
  });

  return { refContent, ...currState };
}

const Context = React.createContext();

export const useSizeContainer = () => {
  return useContext(Context);
};

export const Container = (props) => {
  const { children, height: heightScale = 1 } = props;
  const currContainer = useSizeContainer();
  const { refContent, width, height, top } = useHeightAvailable(currContainer);

  const style = {
    width: width + "px",
    height: height * heightScale + "px",
    overflowY: "auto",
  };

  const value = useMemo(() => ({ width, height, top }), [width, height]);

  return (
    <>
      <div ref={refContent} />
      <div style={style}>
        <Context.Provider value={value}>{children}</Context.Provider>
      </div>
    </>
  );
};
